module.exports = __webpack_public_path__ + "img/appointments-dashboard2.4f9a0a85.jpg";